import * as React from 'react';
import { FormSectionElements, FormSections, FormSubSections, ProgramContainer } from '../entities/formTemplateDataType';
import { ElementComponent } from './ElementComponent';
import { User } from '../entities/User';
import { getParentSection, getRootComponent } from "../utilities/ElementUtils";
import { formatField } from "../utilities/PatternFormatterUtils";

interface Props {
  isEng: boolean;
  activeSubSection: FormSubSections;
  optionsFieldValue?: Map<string, string>;
  user?: User;
  editable: boolean;
  roleBasedEditable?: boolean;
  topEntity?;
  roleBased?: boolean;
  ownerEditableOnly?: boolean;
  renderHeader?: boolean;
  returnIndex?: number;
  callback: (programContainer: ProgramContainer) => void;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
  callbackValidate?: (errors: any, fromAPI?: boolean) => void;
  onBusyChange?: (isBusy: boolean) => void;
  style?: React.CSSProperties;
  callbackGeneratePdf?: (field: FormSectionElements) => void;
}

interface State {
  // activeSubSection: FormSubSections;
  // editable: boolean;
  // topEntity;
}

export class SubSectionComponent extends React.Component<Props, State> {
  section : FormSections;
  UseAsterisks
  HideOptionalText
  constructor(props: Props) {
    super(props);

    // this.state = {
    //   activeSubSection: this.props.activeSubSection,
    //   editable: this.props.editable,
    //   topEntity: this.props.topEntity
    // };
    this.section = getParentSection(this.props.activeSubSection);
    this.UseAsterisks = this.props.activeSubSection.parent?.parent?.UseAsterisks;
    this.HideOptionalText = this.props.activeSubSection.parent?.parent?.HideOptionalText;


  }

  componentWillUnmount() {
    console.log("!!!!!!! SubSectionComponent is being REMOVED from the DOM !!!");
    console.trace(); 
  }

  //get subsection element with FilterField
  render() {
    var panelContents = [];
    const HtmlToReactParser = require('html-to-react').Parser;
    let numSubsections=null
    if(!this.props.activeSubSection.Id && this.props.activeSubSection.SubsectionBackground=="rgb(242, 242, 242)"){
      numSubsections= 'new'
    }else{
      numSubsections= this.props.activeSubSection.Id
    }
    const htmlToReactParser = new HtmlToReactParser();
    panelContents.push(<div style={{ display: "flex", background: this.props.activeSubSection.SubsectionBackground ?? 'transparent', width: '100%', maxWidth: '100%' }} id={'subSec_'+numSubsections} key={'subSecKey_'+numSubsections}>
      {/* <div key={'subSec_' + this.props.activeSubSection.Id} style={{ display: this.props.activeSubSection.Visible == false ? 'none' : 'block', width: '100%' }}> */}
       <div key={'subSec_' + this.props.activeSubSection.Id}
        style={
          // merge default style with parent-provided style; parent style overrides defaults when provided
          Object.assign(
            {
              display: this.props.activeSubSection.Visible == false ? 'none' : 'block',width: '100%',
              // NOTE: removed automatic BXP-based flex:1 here so parent can fully control layout via `style` prop
            },
            this.props.style || {}
          )
        }
      >
       
        {this.generatePanelContent(this.props.activeSubSection)}
      </div>
      {this.props.activeSubSection.Image &&
        <div style={{
          width: "100%",               // fill parent's width
          height: "auto",
          backgroundImage: `url(${this.props.activeSubSection.Image})`, // URL or base64
          backgroundSize: "cover",     // fill and crop if needed
          backgroundPosition: "center",// center the image
          backgroundRepeat: "no-repeat",
          display: "flex",             // optional: for content inside
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "5px",
        }} />}
    </div>

    );
    //panelContents.push(<br key={'br_' + this.props.activeSubSection.Id} />);

    return panelContents;
  }

  createElementComponent = (element: FormSectionElements, subSection: FormSubSections, index: number) => {
    element.findFieldByName = (fieldName) => {
      const root = this.props.activeSubSection.parent.parent;

      const formList = root.ListOfFormSections;
      let eleReturned;
      try {
        formList.forEach(section => {
          if (section.Visible == false) return;
          section.ListOfFormSubSections.forEach(sub => {
            const elements = sub.ListOfFormSectionElements;
            elements.forEach(ele => {
              if (ele.LoadBindName == fieldName) {
                eleReturned = ele;
                throw new Error('Exit all loops');
              }
            })
          })
        });
      } catch {
        return eleReturned;
      }
      return null;
    }
    element.findAnyFieldByName = (fieldName) => {
      const root = this.props.activeSubSection.parent.parent;

      const formList = root.ListOfFormSections;
      let eleReturned;
      try {
        formList.forEach(section => {
          section.ListOfFormSubSections.forEach(sub => {
            const elements = sub.ListOfFormSectionElements;
            elements.forEach(ele => {
              if (ele.LoadBindName == fieldName) {
                eleReturned = ele;
                throw new Error('Exit all loops');
              }
            })
          })
        });
      } catch {
        return eleReturned;
      }
      return null;
    }
    element.findSectionByTitle = (sectionTitle) => {
      const root = this.props.activeSubSection.parent.parent;
      const formList = root.ListOfFormSections as FormSections[];
      for (let form of formList) {
        if (form.ENUTitle == sectionTitle) {
          return form;
        }
      }
      return null;
    }
    element.formatField = formatField;

    return (<>
      <ElementComponent
          key={element.LoadBindName + "_" + this.section.Id + "_" + subSection.Id + '_ElementComponent_field_' + element.Id + '_' + index}
          isEng={this.props.isEng}
          field={element}
          editable={this.props.editable}
          roleBasedEditable={this.props.roleBasedEditable}
          callbackElement={(container) => {
            this.props.callback(container);
          }}
          optionsFieldValue={this.props.optionsFieldValue}
          user={this.props.user}
          topEntity={this.props.topEntity}
          roleBased={this.props.roleBased}
          usedForFilter={false}
          ownerEditableOnly={this.props.ownerEditableOnly}
          UseAsterisks={this.UseAsterisks}
          HideOptionalText={this.HideOptionalText}
          returnIndex={this.props.returnIndex}
          onBusyChange={(isBusy) => {this.props.onBusyChange(isBusy)}}
          callbackValidate={(errors, fromAPI) => this.props.callbackValidate(errors, fromAPI)}
          callbackStepIndex={(index, returnIndex) => this.props.callbackStepIndex(index, returnIndex)}
          callbackGeneratePdf={(fld) => {
            this.props.callbackGeneratePdf?.(fld);
          }}
        />    
    </>)
  }

  findAllInlineCenteredSectionElements = (sectionElements: FormSectionElements[]) => {
    return sectionElements.filter(element => element.inlineStyling && element.ButtonProps?.buttonPosition === 'right');
  }

  generatePanelContent = (subSection: FormSubSections) => {
    var controlArray = [];
    const programContainer = getRootComponent(subSection);

    const filteredSectionElements = subSection.ListOfFormSectionElements
      .filter(item => true !== item.FieldMustBeAtTop)
      .sort((a, b) => a.Sequence - b.Sequence);
    for (let i = 0; i < filteredSectionElements.length; i++) {
      if (!this.props.editable && filteredSectionElements[i].hideInSummary) {  // Do nothing
      } else if (filteredSectionElements[i].inlineStyling && (!filteredSectionElements[i].Centered) && 
          filteredSectionElements[i].ButtonProps?.buttonPosition === 'right') {  // Inline button-elements that are displayed on the right side of the page.
        const inlineCenteredElements = this.findAllInlineCenteredSectionElements(filteredSectionElements);  // Assuming all button elements in the same subsection are displayed on the same line.
        const html = [];
        inlineCenteredElements.forEach((element, j) => {
          html.push(this.createElementComponent(element, subSection, j));
          i++
        });
        controlArray.push(<>
             <div
                key={filteredSectionElements[i-1].LoadBindName + "_" + subSection.Id + '_stable_wrapper_' + filteredSectionElements[i-1].Id}
                className={this.props.editable === false ? "pdf-row" : ""}
                style={{
                  display: 'inline-block', textAlign: 'right', width: '100%',
                }}
              >
                {html}
              </div>
        </>)
      } else {  // All other elements.
        controlArray.push(
          <div
            key={filteredSectionElements[i].LoadBindName + "_" + subSection.Id + '_stable_wrapper_' + filteredSectionElements[i].Id}
            className={(this.props.editable === false) && (filteredSectionElements[i].Datatype !== 'Button') ? "pdf-row" : ""}
            style={{
              display: filteredSectionElements[i].inlineStyling ? 'inline-block' : 'block',
              ...(this.props.editable === false && programContainer.isHorizontalLayout ? { borderBottom: 'solid 1px #d5d5d5' } : {})
            }}
          >
            {this.createElementComponent(filteredSectionElements[i], subSection, i)}
          </div>
        );
      }
    }

    return controlArray;
  }
}
